import ReplyByAI from "./ReplyByAI";

// Wrapper component for different AI models
const ReplyByModel = (props) => {
  return (
    <ReplyByAI
      {...props}
      modelName="AI"
    />
  );
};

export default ReplyByModel;
